<template>
  <div class="main-content">
    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card mt-5">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">Presence Data</h4>
            </div>
            <div class="card-body">
              <vue-good-table
                :columns="columns"
                :rows="list"
                :line-numbers="true"
                :search-options="{
                  enabled: true,
                  externalQuery: searchTerm,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: pageLength,
                }">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'access_time'">
                    {{ formatDate(props.row.access_time) }}
                  </span>
                  <div
                    v-else-if="props.column.field == 'action'"
                    class="text-center"
                  >
                    <button
                      class="btn btn-sm btn-warning me-2"
                    >
                      Detail
                    </button>
                  </div>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="m-3"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                      >
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "presenceList",
  computed: {
    columns() {
      return this.$store.getters["presence/columns"];
    },
    list() {
      return this.$store.getters["presence/list"];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
    };
  },
  mounted() {
    console.log(this);
    this.getList();
  },
  methods: {
    getList() {
      this.$store.dispatch("presence/GET_LIST");
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      }
      return date;
    },
    remove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("location/DELETE", { id: id }).then(() => {
            this.$swal("Deleted!", "Location Deleted!.", "success");
            this.getList();
          });
        }
      });
    },
  },
};
</script>
